export default "__VITE_ASSET__CaGO7zeQ__"